/** Theme-aware border colour for the widget shell and core navigation tab rail. */
export const WIDGET_TRACK_BORDER_COLOR =
  "light-dark(var(--mantine-color-gray-3), var(--mantine-color-gray-dark-9))";

/** 1px border using {@link WIDGET_TRACK_BORDER_COLOR}. */
export const WIDGET_TRACK_BORDER = `1px solid ${WIDGET_TRACK_BORDER_COLOR}`;

/** Widget card / header surface background. */
export const WIDGET_SHELL_BG =
  "light-dark(var(--mantine-color-gray-0), var(--mantine-color-gray-dark-11))";

export const WALLET_ADDRESS_BADGE_TEXT_COLOR =
  "light-dark(var(--mantine-color-gray-6), var(--mantine-color-gray-5))";

export const WALLET_ADDRESS_BADGE_HOVER_BG =
  "light-dark(var(--mantine-color-gray-1), var(--mantine-color-gray-dark-10))";

/** Gap between the address label and chevron (tighter than edge padding). */
export const WALLET_ADDRESS_BADGE_ICON_GAP = "var(--mantine-spacing-sm)";

/** Default address badge surface — must override Mantine `--badge-bg` / `background`. */
export const WALLET_ADDRESS_BADGE_BASE_STYLE = {
  backgroundColor: WIDGET_SHELL_BG,
  background: WIDGET_SHELL_BG,
  "--badge-bg": WIDGET_SHELL_BG,
  border: `1px solid ${WIDGET_TRACK_BORDER_COLOR}`,
  "--badge-bd": `1px solid ${WIDGET_TRACK_BORDER_COLOR}`,
  color: WALLET_ADDRESS_BADGE_TEXT_COLOR,
  "--badge-color": WALLET_ADDRESS_BADGE_TEXT_COLOR,
  textTransform: "none",
  letterSpacing: "normal",
  fontWeight: 400,
} as const;

/** Hover surface — slightly darker in light mode, slightly lighter in dark mode. */
export const WALLET_ADDRESS_BADGE_HOVER_STYLE = {
  backgroundColor: WALLET_ADDRESS_BADGE_HOVER_BG,
  background: WALLET_ADDRESS_BADGE_HOVER_BG,
  "--badge-bg": WALLET_ADDRESS_BADGE_HOVER_BG,
} as const;

/** Mantine Badge root styles — md label with lg chip dimensions (header network badge). */
export const WALLET_NETWORK_BADGE_ROOT_STYLES = {
  height: "var(--badge-height-lg)",
  paddingInline: "var(--badge-padding-x-lg)",
  fontSize: "var(--badge-fz-md)",
  lineHeight: "calc(var(--badge-height-lg) - calc(0.125rem * var(--mantine-scale)))",
} as const;
